import { Directive, ElementRef, Input, OnInit, Renderer2, RendererFactory2 } from '@angular/core';

import { StaticFileUrlService } from 'Angular/services/static-file-url.service';

// We need to import svgxuse so that our external loading of SVGs works with Mobile Safari.
import 'svgxuse';

/**
 *
 * Image Directive
 *
 * Displays an image
 *
 * Input Properties:
 *
 *  imageSrc: The location of the image file in its app's static folder (e.g. "integrations/images/black-diamond-logo.png")
 *
 */

@Directive({
    standalone: false,
    selector: 'img[ycnImage]',
})
export class ImageDirective implements OnInit {
    @Input() imageSrc!: string;

    private renderer: Renderer2;

    constructor(
        private el: ElementRef,
        private rendererFactory: RendererFactory2,
        private staticFileUrlService: StaticFileUrlService
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    ngOnInit(): void {
        this.renderer.addClass(this.el.nativeElement, this.imageSrc);
        this.staticFileUrlService.getAbsoluteURL(this.imageSrc).subscribe((url: string) => {
            this.renderer.setAttribute(this.el.nativeElement, 'src', url);
        });
    }
}
